// Chakra imports
import {
  Box,
  Button,
  Flex,
  Icon,
  Image,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { apiurl } from "APIURL";
// Custom components

import Card from "components/card/Card";
import React, { useState } from "react";
import Dropzone from "views/admin/profile/components/Dropzone";
// Assets
import axios from "axios";
import { MdUpload } from "react-icons/md";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { getProfileData, setProfile } from "redux/slices/userSlice";

export default function Upload(props: {
  used?: number;
  total?: number;
  [x: string]: any;
}) {
  const { used, total, ...rest } = props;
  const dispatch = useAppDispatch();
  const profile = useAppSelector(getProfileData);
  // Chakra Color Mode
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const brandColor = useColorModeValue("brand.500", "white");
  const textColorSecondary = "gray.400";
  const [fileInputState, setFileInputState] = useState("");
  const [previewSource, setPreviewSource] = useState(null);
  const [selectedFile, setSelectedFile] = useState();
  const [successMsg, setSuccessMsg] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [disabled, setDisabled] = useState(false);
  const handleFileInputChange = React.useCallback((acceptedFiles: any) => {
    console.log("changing");
    /*const file = files.target.files[0];
        previewFile(file);
        setSelectedFile(file);
        setFileInputState(files.target.value);*/
    previewFile(acceptedFiles[0]);
    setSelectedFile(acceptedFiles[0]);
    setFileInputState(acceptedFiles[0]);
    acceptedFiles.forEach((file: any) => {
      const reader = new FileReader();

      reader.onabort = () => console.log("file reading was aborted");
      reader.onerror = () => console.log("file reading has failed");
      reader.onload = () => {
        // Do whatever you want with the file contents
        const binaryStr = reader.result;
        console.log(binaryStr);
      };
      reader.readAsArrayBuffer(file);
    });
  }, []);

  const previewFile = (file: any) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setPreviewSource(reader.result);
    };
  };

  const handleSubmitFile = () => {
    //e.preventDefault();
    if (!selectedFile) return;
    const reader = new FileReader();
    reader.readAsDataURL(selectedFile);
    /*reader.onloadend = () => {
            uploadImage(reader.result.toString());
        };*/
    console.log(selectedFile);
    uploadImage(selectedFile);
    reader.onerror = () => {
      console.error("AHHHHHHHH!!");
      setErrMsg("something went wrong!");
    };
    setDisabled(true);
  };

  const uploadImage = async (file: File) => {
    const formData = new FormData();
    formData.append("file", file);
    for (var key of formData.entries()) {
      console.log(key[0] + ", " + new Object(key[1]));
    }
    try {
      const response = await axios.post(apiurl + "/file/upload", formData);
      console.log(response.data);
      updateImage(response.data, profile.userId);

      setFileInputState("");
      setPreviewSource("");
      setSuccessMsg("Image uploaded successfully");
    } catch (err) {
      console.error(err);
      setErrMsg("Something went wrong!");
    }
  };
  const updateImage = async (image: string, id: string) => {
    try {
      const res = await axios.patch(`${apiurl}/user/updateProfile/${id}`, {
        image: image,
      });
      console.log(res.data);
      dispatch(setProfile({ ...profile, image: res.data.image }));
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <Card {...rest} mb="20px" alignItems="center" p="20px">
      <Flex h="100%" direction={{ base: "column", "2xl": "row" }}>
        <Dropzone
          onDrop={handleFileInputChange}
          w={{ base: "100%", "2xl": "100%" }}
          me="36px"
          maxH={{ base: "60%", lg: "50%", "2xl": "100%" }}
          minH={{ base: "60%", lg: "50%", "2xl": "100%" }}
          content={
            <Box>
              <Icon as={MdUpload} w="80px" h="80px" color={brandColor} />
              <Flex justify="center" mx="auto" mb="12px">
                <Text fontSize="xl" fontWeight="700" color={brandColor}>
                  Modifier votre photo de profil
                </Text>
              </Flex>
              <Text fontSize="sm" fontWeight="500" color="secondaryGray.500">
                Pour un meilleur look!
              </Text>
            </Box>
          }
          value={fileInputState}
        />
        <Flex direction="column" pe="44px">
          {previewSource ? (
            <Image marginY={3} rounded="lg" src={previewSource} />
          ) : (
            <>
              <Text
                color={textColorPrimary}
                fontWeight="bold"
                textAlign="start"
                fontSize="2xl"
                mt={{ base: "20px", "2xl": "50px" }}
              ></Text>
              <Text
                color={textColorSecondary}
                fontSize="md"
                my={{ base: "auto", "2xl": "10px" }}
                mx="auto"
                textAlign="start"
              ></Text>
            </>
          )}
          <Flex w="100%">
            <Button
              onClick={handleSubmitFile}
              me="100%"
              mb="50px"
              w="140px"
              minW="140px"
              variant="brand"
              mt={{ base: "20px", "2xl": "auto" }}
              fontWeight="500"
            >
              Modifier
            </Button>
          </Flex>
        </Flex>
      </Flex>
    </Card>
  );
}
